namespace ImportEnums {
  export enum ImportResponseErrorCodes {
    FAILED_TO_TRIGGER_IMPORT = "FAILED_TO_TRIGGER_IMPORT",
  }
  export namespace POST {
    export namespace Response {
      export enum ImportResponseErrorCodes {
        FAILED_TO_TRIGGER_IMPORT = "FAILED_TO_TRIGGER_IMPORT",
      }
    }
  }
}
export default ImportEnums;
